import Dialog from "../../../components/Dialog/Dialog";
import DialogTextField from "../../../components/DialogTextField/DialogTextField";
import React, { useEffect, useState } from "react";
import Select from "../../../components/Select/Select";
import { Privilege } from "../Models/Privilige";
import {
  DESCRIPTION,
  NAME,
  PRIVILEGE_REFERENCE_NAME,
} from "../../../utility/TextLabels";

type PrivilegeDialogProps = {
  title: string;
  existingId?: string;
  existingName?: string;
  existingReferenceName?: string;
  existingDescription?: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (privilege: Privilege) => void;
};

const PrivilegeDialog: React.FC<PrivilegeDialogProps> = ({
  title,
  existingId,
  existingName,
  existingReferenceName,
  existingDescription,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [name, setName] = useState(existingName ?? "");
  const [referenceName, setReferenceName] = useState(
    existingReferenceName ?? ""
  );
  const [description, setDescription] = useState(existingDescription ?? "");
  const [isSubmitValid, setIsSubmitValid] = useState(false);

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleReferenceNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setReferenceName(event.target.value);
  };

  const handleDescriptionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDescription(event.target.value);
  };

  useEffect(() => {
    const areMandatoryFieldsFilled =
      name.length > 1 && referenceName.length > 1;
    const isReferenceNameWithoutSpaces = !referenceName.includes(" ");
    setIsSubmitValid(areMandatoryFieldsFilled && isReferenceNameWithoutSpaces);
  }, [name, referenceName]);

  const prepareSubmit = () => {
    const privilege: Privilege = {
      id: existingId,
      name: name,
      referenceName: referenceName,
      description: description,
    };

    onSubmit(privilege);
    prepareClose();
  };

  const prepareClose = () => {
    setName(existingName ?? "");
    setReferenceName(existingReferenceName ?? "");
    setDescription(existingDescription ?? "");
    onClose();
  };

  return (
    <Dialog
      title={title}
      open={isOpen}
      onClose={prepareClose}
      onSubmit={prepareSubmit}
      isSubmitEnabled={isSubmitValid}
    >
      <DialogTextField
        label={NAME}
        name={existingName}
        inputValue={name}
        onChange={handleNameChange}
      />
      <DialogTextField
        label={PRIVILEGE_REFERENCE_NAME}
        name={existingReferenceName}
        inputValue={referenceName}
        onChange={handleReferenceNameChange}
        disabled={existingReferenceName ? true : false}
      />
      <DialogTextField
        label={DESCRIPTION}
        rows={3}
        name={existingDescription}
        inputValue={description}
        onChange={handleDescriptionChange}
      />
      <Select />
    </Dialog>
  );
};

export default PrivilegeDialog;
